<template lang="pug">
  .layout-view
    controls-panel
    storage-tabs
    template(v-if="!isMobile")
      deliveries-table
    template(v-if="isMobile")
      deliveries-table-mobile
</template>

<script>
import adaptationMixin from '@/mixins/adaptation.mixin.js'

import ControlsPanel from './ControlsPanel'
import StorageTabs from '../common/StorageTabs'

const DeliveriesTable = () => import('./table/DeliveriesTable')
const DeliveriesTableMobile = () => import('./table/DeliveriesTableMobile')

export default {
  name: 'Deliveries',

  mixins: [adaptationMixin],

  components: {
    ControlsPanel,
    StorageTabs,
    DeliveriesTable,
    DeliveriesTableMobile
  }
}
</script>
